
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    totalOrdenesPago: 0,
    
});






export const useOrdenesPagoStore = create()(
    devtools(
        storeApi
    )
)
